type Elements = {
  buttons: HTMLAnchorElement[]
  labels: HTMLLabelElement[]
};

type Blanks = {
  elements: Elements;
  init: () => void;
  handleButtonClick: (e: MouseEvent | KeyboardEvent, button: HTMLAnchorElement) => void;
  handleLabelClick: (e: MouseEvent | KeyboardEvent, label: HTMLLabelElement) => void;
};

const blanks: Blanks = {
  elements: {
    buttons: [],
    labels: [],
  },

  init() {
    this.elements.buttons = Array.from(document.querySelectorAll('.blank-button'));
    this.elements.labels = Array.from(document.querySelectorAll('.blanks-options label'));

    if (this.elements.buttons.length) {
      this.elements.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.handleButtonClick(e, button));
        button.addEventListener('keypress', (e) => {
          if (e.key !== 'Enter') return;
          this.handleButtonClick(e, button);
          e.stopPropagation();
        });
      });
    }

    if (this.elements.labels.length) {
      this.elements.labels.forEach(label => {
        label.addEventListener('click', (e) => this.handleLabelClick(e, label));
        label.addEventListener('keypress', (e) => {
          if (e.key !== 'Enter') return;
          this.handleLabelClick(e, label);
          e.stopPropagation();
        });
      });
    }
  },

  handleButtonClick(e: MouseEvent | KeyboardEvent, button: HTMLAnchorElement) {
    e.preventDefault();

    const key = button.dataset.blank;
    const options = document.querySelector(`.blanks-options[data-options="${key}"]`);

    if (options) {
      options.classList.add('show');
      options.firstElementChild?.firstElementChild?.querySelector('label')?.focus();
    }
  },

  handleLabelClick(e: MouseEvent | KeyboardEvent, label: HTMLLabelElement) {
    e.preventDefault();

    const key = label.dataset.label;
    const button: HTMLAnchorElement | null = document.querySelector(`.blank-button[data-blank="${key}"]`);
    const options = document.querySelector(`.blanks-options[data-options="${key}"]`);

    if (button) {
      button.classList.add('selected');
      button.innerHTML = `${label.textContent} <i class="fas fa-angle-down"></i>`;
      button.focus();
    }

    if (options) {
      options.classList.remove('show');
    }
  },
};

export default blanks;
